"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var CommentGroupStore_1 = __importDefault(require("../CommentGroupStore"));
var ActiveCommentThreadStore = (function () {
    function ActiveCommentThreadStore() {
        this.activeThreadStore = null;
    }
    ActiveCommentThreadStore.prototype.setActiveThread = function (groupStore) {
        this.activeThreadStore = groupStore;
    };
    ActiveCommentThreadStore.prototype.clearActiveThread = function () {
        this.activeThreadStore = null;
    };
    ActiveCommentThreadStore.prototype.isActiveThread = function (groupStore) {
        var _this = this;
        return (0, mobx_1.computed)(function () {
            return _this.activeThreadStore === groupStore;
        }).get();
    };
    var _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ActiveCommentThreadStore.prototype, "activeThreadStore", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof CommentGroupStore_1.default !== "undefined" && CommentGroupStore_1.default) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], ActiveCommentThreadStore.prototype, "setActiveThread", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ActiveCommentThreadStore.prototype, "clearActiveThread", null);
    return ActiveCommentThreadStore;
}());
exports.default = ActiveCommentThreadStore;
